import { render } from "./OrderSingle.vue?vue&type=template&id=4148d3ec&scoped=true"
import script from "./OrderSingle.vue?vue&type=script&lang=js"
export * from "./OrderSingle.vue?vue&type=script&lang=js"

import "./OrderSingle.vue?vue&type=style&index=0&id=4148d3ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4148d3ec"]])

export default __exports__